import React, {useEffect, useMemo} from 'react';
import DidiSelectionCommonColumn from "../common-column";
import {tabColIconSucOrErrMap} from "../../../../../consts";


interface IComponentProps {
  data?: any
}
const ShangjiafenColumn: React.FC<IComponentProps> = (props) => {
  const { data } = props

  const {
    store_srv_score,
    store_srv_score_ok
  } = data

  const imgUrl = useMemo(() => {
    return tabColIconSucOrErrMap[store_srv_score_ok]
  }, [store_srv_score_ok])

  useEffect(() => {



  }, []);

  return (
    <DidiSelectionCommonColumn
      name={store_srv_score}
      imgUrl={imgUrl}/>
  );
};

export default ShangjiafenColumn;
